/**
 * This file serves as the entry point for the Vue application.
 * It initializes the Vue application and connects the router and Vuex store.
 */

import './style.css';
import 'leaflet/dist/leaflet.css';
import { createApp } from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper'; // 1. Import VueHtmlToPaper
import App from './App.vue'
import router from "./router"
import store from './store'
import { onSessionExpired } from './session'

import PortalVue from 'portal-vue';

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.warn('Globally caught unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise,
    type: event.type,
    stack: event.reason?.stack
  });
  // Prevent error from showing in console
  event.preventDefault();
  return false;
});

const app = createApp(App)

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000,
  autoClose: true,
  windowTitle: window.document.title,
}

app.use(VueHtmlToPaper, options); // if you don't need any special options, you can use just `app.use(VueHtmlToPaper);`

app.use(PortalVue);

app.use(router);
app.use(store);

// Vypršelé přihlášení: odhlásit, poslat na přihlášení s hláškou a po
// úspěšném loginu vrátit uživatele tam, kde byl (rozpracované hlášení
// si Report.vue drží v konceptu).
onSessionExpired(() => {
  store.commit('setLoggedIn', false);
  store.commit('setRole', null);
  const current = router.currentRoute.value;
  if (current.path === '/sign-in') return;
  router.push({
    path: '/sign-in',
    query: { expired: '1', redirect: current.fullPath },
  });
});

app.mount('#app')

